import React from 'react'
// import { useSelector } from 'react-redux'
import { useInternationalization } from '../../features/i18n'
import { CarouselQuotes } from '../carousel-quotes'
import { TestimoniAdder } from '.'
import { useSelector } from 'react-redux'

// const data = [
//   {
//     text: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
//     name: "Ahmad Suhari",
//   },
//   {
//     text: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
//     name: "Ahmad Suhari",
//   }
// ]

const TestimoniSection = ({ data, fetcher, apiKey, singleStateKey }) => {
  const { translate } = useInternationalization()
  const { isVerified, isOfficial } = useSelector(state => state.account)

  return (
    <div className="w-full lg:w-7/12">
      <div className="mb-4 lg:mb-8">
        <CarouselQuotes
          title={translate('GENERAL', 'testimonial')}
          data={data}
        />
      </div>
      {
        (isVerified || isOfficial) &&
        <TestimoniAdder
          type={isOfficial ? 'nonUser' : isVerified ? 'user' : undefined}
          fetcher={fetcher}
          apiKey={apiKey}
          singleStateKey={singleStateKey}
        />
      }
    </div>
  )
}

export { TestimoniSection }
